module.exports = __webpack_public_path__ + "img/icn_brand4.107bef36.svg";